export default __webpack_public_path__ + "images/826f388bc500a6910712461a4b948d29-jcb.svg";